import { useCallback, useEffect, useState } from 'react';
import { changesApi } from '../../../services/changesApi';
import type { ChangeRequest } from '../../../types/changes';
import { getApiErrorMessage } from '../../../utils/apiError';

export function useChangeDetail(changeId: number) {
  const [change, setChange] = useState<ChangeRequest | null>(null);
  const [allowedTransitions, setAllowedTransitions] = useState<string[]>([]);
  const [blockedTransitions, setBlockedTransitions] = useState<
    Array<{ status: string; reason: string }>
  >([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!changeId) return;
    setLoading(true);
    setError(null);
    try {
      // As transições são acessórias: uma falha nelas não pode impedir o detalhe de aparecer.
      const [detail, transitions] = await Promise.all([
        changesApi.getById(changeId),
        changesApi.allowedTransitions(changeId).catch(() => null),
      ]);
      setChange(detail);
      setAllowedTransitions(Array.isArray(transitions?.allowed) ? transitions!.allowed : []);
      setBlockedTransitions(Array.isArray(transitions?.blocked) ? transitions!.blocked : []);
    } catch (err) {
      setChange(null);
      setError(getApiErrorMessage(err, 'Falha ao carregar mudança.'));
    } finally {
      setLoading(false);
    }
  }, [changeId]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return {
    change,
    setChange,
    allowedTransitions,
    blockedTransitions,
    loading,
    error,
    reload,
  };
}
